export default "__VITE_ASSET__xbt_xzA6__"